import React, { useState, useEffect } from "react";
// Import Swiper React components
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import SectionHeader from "./SectionHeader";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import WebsiteCard from "../../../components/WebsiteCard";
import WebsitesPlaceholder from "./placeholders/WebsitesPlaceholder";

const Websites = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isWeblinksLoading, setIsWeblinksLoading] = useState(true);
  const [weblinks, setWeblinks] = useState([]);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/weblinks/`)
      .then((res) => {
        setWeblinks(res.data);
      })
      .then(() => {
        setIsWeblinksLoading(false);
      });
  }, []);

  return (
    <div className="websites-wrapper">
      <div className="container">
        <div className="row">
          <SectionHeader
            title={getContent(
              content,
              "Websites of state institutions of Turkmenistan",
              lang
            )}
            content={getContent(content, "Services content", lang)}
          />
        </div>
        <div className="row">
          <div className="col-12">
            {isWeblinksLoading === true ? (
              <WebsitesPlaceholder />
            ) : (
              <Swiper
                modules={[Navigation]}
                spaceBetween={1}
                breakpoints={{
                  350: {
                    slidesPerView: 2,
                  },
                  600: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 6,
                  },
                }}
                navigation={{
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
              >
                {weblinks.map((weblink) => (
                  <SwiperSlide key={weblink.id}>
                    <WebsiteCard weblink={weblink} />
                  </SwiperSlide>
                ))}
                <div className="nav-btn prev" ref={navigationPrevRef}>
                  &#8249;
                </div>
                <div className="nav-btn next" ref={navigationNextRef}>
                  &#8250;
                </div>
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Websites;
